import { create } from 'zustand'
import type { User } from '~/types/user.types'

type UserStore = {
  user: User | null
  logout: () => void
  setUser: (user: User) => void
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  logout: () => set({ user: null }),
  setUser: (user: User) => set({ user }),
}))
